(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/kyc/kyc.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/kyc/kyc.js');
'use strict';

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const service = svs.playerRegistration.service;
const helpers = svs.playerRegistration.helpers;
const showTechnicalKycError = svs.playerRegistration.dialogs.showTechnicalKycError;
const trackKycSavingAsync = svs.playerRegistration.tracking.trackKycSavingAsync;
const _svs$playerRegistrati = svs.playerRegistration.components,
  DesktopContentConstrain = _svs$playerRegistrati.DesktopContentConstrain,
  Header = _svs$playerRegistrati.Header,
  PageTitle = _svs$playerRegistrati.PageTitle;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const routes = svs.playerRegistration.constants.routes;
const Kyc = () => {
  const history = useHistory();
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const returnUrl = helpers.getReturnUrl() || svs.core.urlMapping.get('newCustomer');
  const isNewCustomerOnlyStep1 = returnUrl === svs.core.urlMapping.get('newCustomer');
  const isShortRegistrationFlow = extraData.isShortRegistrationFlow || isNewCustomerOnlyStep1;
  const isResume = helpers.getIsResume();
  const kycContainerRef = useRef();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerregistrationreact),
    startTime = _ReactRedux$useSelect.startTime,
    subscription = _ReactRedux$useSelect.subscription,
    gift = _ReactRedux$useSelect.gift;
  const navigateToNext = useCallback(async () => {
    const accountCreatedUrl = "".concat(routes.ACCOUNT_CREATED).concat(returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : '');
    const isBlocked = svs.core.userSession.isBlocked();
    if (isBlocked) {
      const showNationalSuspensionMessage = () => new Promise(resolve => {
        svs.accountservices.national_suspension_message.showNationalSuspensionMessage(() => resolve());
      });
      await showNationalSuspensionMessage();
    }

    if (isShortRegistrationFlow) {
      svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
    } else {
      history.push(accountCreatedUrl);
    }
  }, [history, subscription, gift]);

  const onKycQuestionsComplete = useCallback(async kycStatus => {
    const parsedKycStatus = parseInt(kycStatus, 10);
    if (startTime) {
      await trackKycSavingAsync({
        duration: Date.now() - startTime
      });
    }

    if (parsedKycStatus) {
      const showTechnicalKycError = () => new Promise(resolve => {
        svs.components.kyc_messages.showKYCMessage(parsedKycStatus, () => resolve());
      });
      await showTechnicalKycError();
    }
    const preferencesResponse = await service.checkFreshPreferencesDataAsync(parsedKycStatus);
    if (preferencesResponse.error) {
      svs.playerRegistration.logger.warn('Could not retrieve preferences, going to forward new customer without having verified preferences', preferencesResponse.error);
    }

    navigateToNext();
  }, [navigateToNext, startTime]);
  useEffect(() => {
    const kycErrorCallback = async () => {
      await showTechnicalKycError();
      onKycQuestionsComplete();
    };
    svs.core.module.load('/cl/components/react:kyc', null, function () {
      svs.components.kyc.init(kycContainerRef.current, {
        context: this,
        onComplete: onKycQuestionsComplete,
        onError: kycErrorCallback,
        onInitializationError: onKycQuestionsComplete
      });
    }, false);
  }, [onKycQuestionsComplete]);
  return React.createElement(React.Fragment, null, React.createElement(Header, {
    isForceStandardBranding: true
  }), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, null, React.createElement(PageTitle, null, isResume && 'Välkommen tillbaka!' || 'Vi behöver ställa några frågor'), React.createElement("div", {
    ref: kycContainerRef
  }))));
};
svs.playerRegistration.pages.kyc.Kyc = Kyc;

 })(window);